// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card--16x9[data-v-7151244f]{aspect-ratio:16/9}.card--1x1[data-v-7151244f]{aspect-ratio:1}.border-radius-none[data-v-7151244f]{border-radius:0}.box-shadow-cyan[data-v-7151244f]{box-shadow:10px 10px var(--cyan-lighter)}.card[data-v-7151244f]{display:flex;flex:1;flex-direction:column}.card.left[data-v-7151244f]{flex-direction:row}.card.right[data-v-7151244f]{flex-direction:row-reverse}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
